import { createFileRoute, redirect } from "@tanstack/react-router";

// Back in Quality (ADR-048, reverting the move of ADR-046): links from
// that time keep working.
export const Route = createFileRoute("/_app/master-data/inspection-plans")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/quality/inspection-plans", search: search as never, replace: true });
  },
});
